import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import Hero from '../../components/Service/CoursesFreeConversation/Hero';
import Overview from '../../components/Service/CoursesFreeConversation/Overview';
import Outcome from '../../components/Service/CoursesFreeConversation/Outcome';
import About from '../../components/organisms/CoursesAbout';
import Testimonials from '../../components/organisms/Testimonials';
import StartNow from '../../components/organisms/StartNow';

const FreeConversation = (_props) => {
  const { t } = useTranslation('common');
  return (
    <div>
      <Head>
        <title>{t('title.courses.freeConversation')}</title>
        <meta
          name="description"
          content={t('description.courses.freeConversation')}
        />
      </Head>
      <div className="breadCrumb" />
      <Hero />
      <Overview />
      <Outcome />
      <About />
      <Testimonials />
      <StartNow />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default FreeConversation;
